import React, { useEffect, useRef, useState } from 'react'
// import { MdModeEditOutline } from 'react-icons/md'
// import { InstagramEmbed, XEmbed, YouTubeEmbed } from 'react-social-media-embed'
import GetAutoSuggestionsForTags from '../../../Services/Queries/GetAutoSuggestionsForTags'
import CategoryVideo from './CategoryVideo'
import VideoPlatform from './VideoPlatform'
import PreViewVideo from './PreViewVideo'
import VideoGallerysDisplay from './VideoGallerysDisplay'

const VideoGallery = props => {
  const {
    GalleryVideos,
    inputData,
    sendinputdata,
    sendBooleanValueChangeDone,
    disableInput,
  } = props
  const [previewVideo, setPreviewVideo] = useState({
    path: '',
    title: '',
    videoPlatform: '', // Set default platform to YouTube
    galleryTags: [],
  })
  const [suggestedTags, setSuggestedTags] = useState([])
  const [searchInput, setSearchInput] = useState('')
  const fetchSuggestions = async () => {
    const input = {
      mode: 'TFIDB',
      contentType: 'personGalleryVideos',
      search: searchInput,
      from: 0,
      limit: 1000,
    }

    try {
      const suggestedTags = await GetAutoSuggestionsForTags(input)
      const sortedTags = suggestedTags.items
        ? suggestedTags.items.sort((a, b) =>
            // Assuming tagurl is a string property, adjust the comparison logic as needed
            a.tagURL.localeCompare(b.tagURL),
          )
        : []

      setSuggestedTags(sortedTags)
    } catch (error) {
      console.error('Error fetching suggestions:', error)
    }
  }

  const handleTagCheckboxChange = (tag, checked) => {
    if (checked) {
      // setTags([...tags, tag])
      const previewVideoTemp = { ...previewVideo }
      previewVideoTemp.galleryTags = [...previewVideo.galleryTags, tag]
      setPreviewVideo(previewVideoTemp)
    } else {
      // setTags(tags.filter(t => t !== tag))
      const previewVideoTemp = { ...previewVideo }
      previewVideoTemp.galleryTags = previewVideo.galleryTags.filter(t => t !== tag)
      setPreviewVideo(previewVideoTemp)
    }
  }

  useEffect(() => {
    fetchSuggestions()
  }, [searchInput])

  // Filter suggested tags based on search input
  const filteredTags = suggestedTags.filter(tag =>
    tag.tagURL.toLowerCase().includes(searchInput.toLowerCase()),
  )

  const dragItem = useRef()
  const dragOverItem = useRef()

  const dragStart = (e, position) => {
    dragItem.current = position
  }

  const dragEnter = (e, position) => {
    dragOverItem.current = position
  }

  const drop = () => {
    const GalleryVideosImages = [...GalleryVideos]
    const dragItemContent = GalleryVideosImages[dragItem.current]
    GalleryVideosImages.splice(dragItem.current, 1)
    GalleryVideosImages.splice(dragOverItem.current, 0, dragItemContent)
    const inputDataCopy = { ...inputData }
    inputDataCopy.GalleryVideos = GalleryVideosImages
    sendinputdata(inputDataCopy)
    sendBooleanValueChangeDone('GalleryVideos', true)
  }

  // Handle form field changes
  const handleChange = e => {
    const { name, value } = e.target
    setPreviewVideo({
      ...previewVideo,
      [name]: value,
    })
  }

  const removeVideo = index => {
    const inputDataCopy = { ...inputData }
    const GalleryVideosImages = [...GalleryVideos].filter((item, i) => i !== index)
    inputDataCopy.GalleryVideos = GalleryVideosImages
    sendinputdata(inputDataCopy)
    sendBooleanValueChangeDone('GalleryVideos', true)
  }

  const EditVideo = index => {
    const inputDataCopy = { ...inputData }
    // const imageSIzesTemp = [...imageSIzes]
    const GalleryVideosTemp = [...GalleryVideos]
    const EditValue = GalleryVideosTemp.splice(index, 1)
    // setVideoTittle(EditValue[0].title)
    setPreviewVideo(EditValue[0])
    // imageSIzesTemp.splice(index, 1)
    inputDataCopy.GalleryVideos = GalleryVideosTemp
    // setImageSizes(imageSIzesTemp)
    sendinputdata(inputDataCopy)
    // const url = EditValue[0].path
    // const videoId = url.split('embed/')[1]

    // const ampersandPosition = videoId.indexOf('&')
    // if (ampersandPosition > -1) {
    //   setEmbedVideoId(videoId.substring(0, ampersandPosition))
    // } else {
    //   setEmbedVideoId(videoId ? videoId : '')
    // }

    // setVideoUrl('')
    sendBooleanValueChangeDone('GalleryVideos', true)
  }

  // Handle form submission
  const handleSubmit = () => {
    const GalleryVideosTemp = [...GalleryVideos]

    // e.preventDefault()
    if (previewVideo.videoPlatform === 'youtube') {
      let path = ''
      let thumbnail = ''
      if (previewVideo.path.includes('https://www.youtube.com/') === false) {
        const url = previewVideo.path
        path = url
      } else if (previewVideo.path.includes('embed')) {
        const url = previewVideo.path
        const videoId = url.split('embed/')[1]
        const ampersandPosition = videoId.indexOf('&')
        if (ampersandPosition > -1) {
          path = `https://www.youtube.com/embed/${videoId.substring(0, ampersandPosition)}`
          thumbnail = `https://img.youtube.com/vi/${videoId.substring(
            0,
            ampersandPosition,
          )}/mqdefault.jpg`
          // setEmbedVideoId(videoId.substring(0, ampersandPosition))
        } else {
          // setEmbedVideoId(videoId ? videoId : '')
          path = `https://www.youtube.com/embed/${videoId}`
          thumbnail = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`
        }
      } else {
        // EmbedVideoId of youtube
        const url = previewVideo.path
        const videoId = url.split('v=')[1]
        const ampersandPosition = videoId.indexOf('&')
        if (ampersandPosition > -1) {
          path = `https://www.youtube.com/embed/${videoId.substring(0, ampersandPosition)}`
          thumbnail = `https://img.youtube.com/vi/${videoId.substring(
            0,
            ampersandPosition,
          )}/mqdefault.jpg`
          // setEmbedVideoId(videoId.substring(0, ampersandPosition))
        } else {
          // setEmbedVideoId(videoId ? videoId : '')
          path = `https://www.youtube.com/embed/${videoId}`
          thumbnail = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`
        }
      }

      GalleryVideosTemp.push({
        path,
        thumbnail,
        videoPlatform: previewVideo.videoPlatform,
        title: previewVideo.title,
        galleryTags: previewVideo.galleryTags,
      })
    } else {
      GalleryVideosTemp.push(previewVideo)
    }

    const inputDataCopy = { ...inputData }
    inputDataCopy.GalleryVideos = GalleryVideosTemp
    sendinputdata(inputDataCopy)
    setPreviewVideo({
      path: '',
      title: '',
      videoPlatform: '', // Set default platform to YouTube
      galleryTags: [],
    })
    sendBooleanValueChangeDone('GalleryVideos', true)
  }

  return (
    <div>
      <div>
        <label>Gallery Videos:</label>
        <VideoGallerysDisplay
          GalleryVideos={GalleryVideos}
          dragEnter={dragEnter}
          dragStart={dragStart}
          drop={drop}
          removeVideo={removeVideo}
          disableInput={disableInput}
          EditVideo={EditVideo}
        />
      </div>

      <div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '100px' }}>
          <div>
            <label htmlFor='path'>Path:</label>
            <input
              type='text'
              id='path'
              name='path'
              className='form-control'
              value={previewVideo.path}
              onChange={event => handleChange(event)}
            />
          </div>
          <div>
            <label htmlFor='title'>Title:</label>
            <input
              type='text'
              id='title'
              name='title'
              className='form-control'
              value={previewVideo.title}
              onChange={event => handleChange(event)}
            />
          </div>
        </div>
        <VideoPlatform previewVideo={previewVideo} handleChange={handleChange} />
        <CategoryVideo
          filteredTags={filteredTags}
          searchInput={searchInput}
          setSearchInput={setSearchInput}
          handleTagCheckboxChange={handleTagCheckboxChange}
          previewVideo={previewVideo}
        />

        <PreViewVideo previewVideo={previewVideo} handleSubmit={handleSubmit} />
      </div>
    </div>
  )
}

export default VideoGallery
